import { types } from 'mobx-state-tree'
import { experience } from '../api'
import object_value from '../api/object_value'
import moment from 'moment/moment'
import format_minutes_to_hours from '../api/format_minutes_to_hours'

const City = types.model({
  id: types.identifier(types.number),
  name: types.string,
  created_at: types.string,
  updated_at: types.string
})

const Event = types.model({
  id: types.identifier(types.number),
  date: types.string,
  experience_id: types.number
})

const Experience = types.model({
  id: types.identifier(types.number),
  title: types.string,
  description: types.string,
  language: types.string,
  comment: types.string,
  number_guests: types.number,
  price: types.string,
  location: types.string,
  latitude: types.maybe(types.string),
  longitude: types.maybe(types.string),
  duration: types.number,
  user_id: types.number,
  payment_methods_id: 1,
  created_at: types.string,
  updated_at: types.string,
  image_url: types.optional(types.string, ''),
  category: types.optional(types.frozen, {}), // TODO: create model `Category`
  city: City,
  is_finished: types.boolean,
  events: types.optional(types.array(Event), [])
})

const ExperiencesStore = types.model({
  // TODO: Check what it does
  // map: types.optional(types.map(Experience), {}),
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
})
.views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get events_dates () {
      const events = self.events
      if (!Array.isArray(events) || events.length < 1) {
        return false
      }
      return events.map(event => {
        let date = event.date
        // Convert from [ new Date(), ... ] to [ { date: new Date() }, ... ]
        // Fix: if date is `null` not convert it
        console.log('events_dates - date', date)
        if (date && date instanceof moment) {
          let formatted_date = date.format('YYYY-MM-DD[T]HH:mm:ss[Z]')
          // console.log('events_dates - date z1', formatted_date)
          // console.log('events_dates - date z2', date.toDate().toISOString().split('.')[0] + 'Z')
          return {
            date: formatted_date
          }
        }
      })
    },
    get formatted_duration () {
      console.log('ExperiencesStore - formatted_duration')
      return format_minutes_to_hours(self.data.duration)
    }
  }
))
.actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (id) {
      console.log('ExperiencesStore - get() - id', id)
      experience(id).then(
        self.fetch
      )
    },
    fetch (data) {
      console.log('ExperiencesStore - fetch()', data)
      if (data) {
        // self.map.set(experience.id, experience)
        self.data = data
        self.loaded = true
      }
    },
    clean () {
      console.log('Experience - clean() - self:', self)
      self.data = null
      self.loaded = false
    },
    computed__event ({index = 0, event_id = false}) {
      const events = object_value(self, 'data.events')
      console.log('computed__event - events:', events)

      if (!events || !Array.isArray(events) || events.length < 0) {
        return false
      }

      return event_id
        ? events.find(obj => obj.id.toString() === event_id.toString())
        : events[index]
    }
  })
)

export default ExperiencesStore



// WEBPACK FOOTER //
// ./src/stores/ExperiencesStore.js